import React from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from 'react-icons/lib/fa/home';
import AddDayIcon from 'react-icons/lib/fa/calendar-plus-o';
import ListDaysIcon from 'react-icons/lib/fa/table';

export const Nav = () => (
    <nav className="nav">
        <Link to="/sot">
            <HomeIcon />
        </Link>
        <Link to="/sot/add">
            <AddDayIcon />
        </Link>
        <Link to="/sot/list">
            <ListDaysIcon />
        </Link>
    </nav>
)